import AuthenticationService from "../services/AuthenticationService";

const getUserPermissions = (addAdminPermission = false) => {
  const userData = AuthenticationService.getUserData();
  let tmp = [`user_${userData.id}`]
  if (addAdminPermission) {
    tmp.push("admin")
  }

  return tmp;
};

export default getUserPermissions;
